import React from 'react';
export function Footer() {
  return <footer className="w-full bg-night-deep" data-id="element-98" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-99" data-mp="3gezev8fo7z39">
        <h3 className="font-display text-2xl font-bold tracking-tight text-shuttle" data-id="element-100" data-mp="3ghc5e9zhvhrx">
          Movement Group Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-101" data-mp="36p6buvtlgsam">
          The Responsive Session Arc: a plan that bends to whoever walks in.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-102" data-mp="3uftm3nqzfu0c">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-103" data-mp="36muiocgf6ul">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-night-line pt-5 text-xs leading-relaxed text-white/50" data-id="element-104" data-mp="3qcdsl0a7m9rv">
          Movement Group Ready is a professional resource for trained
          practitioners working within their scope of practice. It does not
          replace clinical training, supervision, clinical judgment or the
          policies of your facility, and it makes no therapeutic or health
          claims. Facilitators are responsible for physical safety, consent and
          opt-out, and for checking that every activity suits their clients and
          setting before it is run. Not affiliated with or endorsed by any
          professional association. No results are guaranteed. © Movement Group
          Ready 2026. All rights reserved.
        </p>
      </div>
    </footer>;
}